module.exports = __webpack_public_path__ + "media/samus.d6636b37.wav";